import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PresentingComplaintsModel } from 'app/EMR/PrimaryExaminationModels/presenting_complaints.model';
import { EMRService } from 'app/EMR/EMR.service';
import { startWith, map, takeUntil } from 'rxjs/operators';

import { DashboardService } from 'app/dashboard/dashboard.service';
import { HelplistService } from 'app/helplist.service';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';


@Component({
  selector: 'app-Present_Complaints',
  templateUrl: './Present_Complaints.component.html',
  styleUrls: ['./Present_Complaints.component.scss'],
})
export class Present_ComplaintsComponent implements OnInit {
  destroypresent$: Subject<boolean> = new Subject<boolean>();
  @Output() compaintEmitter = new EventEmitter<() => void>();

  @Input() showcomplamintmodel: any;
  @Output() parentdata: EventEmitter<any> = new EventEmitter();
  private presenting_complaints_ds: MatTableDataSource<PresentingComplaintsModel>
  private sitelist: any;
  private filteredSiteArray: Observable<any[]>;
  private siteCtrl = new FormControl();
  private myControl = new FormControl();
  private pkId: any;
  private compCategoryId: any;
  showspinner: boolean = false;
  private savetype: any;
  private complaintname: string;
  private filteredSiteArray1: Observable<any[]>;
  private filteredComplaintsList: Observable<any[]>;
  private siteCtrl1 = new FormControl();
  private todaysdate = this.authService.getServerDate;
  private displayedColumns_presenting_complaints: string[] = ['complaint', 'duration', 'site', 'Action'];
  private allComplaintsList: any;
  private allComplaintsEditList: any
  private filteredComplaints: { [key: string]: any[] } = {};
  private searchValue: any;
  private rowSelect: any;
  private unitDuration: string;
  private selectSite: string;
  private enabledisablebtn: boolean = false;
  isheader: boolean = false;
  private complaintNaMe: any
  private editCache: { [key: string]: any } = {};
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<Present_ComplaintsComponent>,
    private emrservice: EMRService,
    private dashboardService: DashboardService,
    private dialog: MatDialog,
    private authService: AuthService,
    private datePipe: DatePipe,
    private helplistservice: HelplistService
  ) {
    this.filteredComplaintsList = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterComplaints(value))
    );
  }

  ngOnInit() {
    const complaint_data = () => {
      this.get_complaints_PE()
    };
    this.compaintEmitter.emit(complaint_data);
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.add_presentingcomplaints = {};
    this.emrservice.share.pipe(takeUntil(this.destroypresent$)).subscribe((x: any) => {

      if (x == 3) {
        this.get_complaints_PE();
        this.getComplaint();
        this.getSite();
        this.rowSelect = -1;
      }
    });
    this.enabledisablebtn = true;
    this.emrservice.pexshare.pipe(takeUntil(this.destroypresent$)).subscribe((x: any) => {
      if (x == 'section7') {
        this.get_complaints_PE();
        this.getComplaint();
        this.getSite();
        this.rowSelect = -1;
      }
    });
    this.get_complaints_PE();
    this.getComplaint();
    this.getSite();

    // AI Scribe — pre-fill chief complaints from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroypresent$)).subscribe(() => this.consumeAiComplaints());
    [900, 2200, 3800].forEach((d) => setTimeout(() => this.consumeAiComplaints(), d));
    // this.complaintupdateEdit()

  }

  /** AI Scribe: add spoken complaints to the Present Complaints grid, then clear. */
  consumeAiComplaints(): void {
    const p: any = this.emrservice.aiWorkupPending;
    const pe = p && p.primaryExam;
    if (!pe || !pe.complaints || !pe.complaints.length) { return; }
    const shown = (this.presenting_complaints_ds && this.presenting_complaints_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }   // already on screen
    const eyeName = (e: string) => e === 'RE' ? 'Right Eye' : e === 'LE' ? 'Left Eye' : 'Both Eyes';
    // dedup any prior AI complaints in the store, then re-add (safe on retries)
    this.emrservice.presentingcomplaints = (this.emrservice.presentingcomplaints || []).filter((r: any) => !r.aiSuggested);
    pe.complaints.forEach((c: any) => {
      this.emrservice.presentingcomplaints.push({
        pkComplaintId: 0, fkVisitId: this.emrservice.visitid,
        complaint: c.complaint || '', duration: c.duration || '', unit: 'Days',
        site: eyeName(c.eye || 'BE'), IsEdit: 0, IsDelete: 0, aiSuggested: true,
      } as any);
    });
    this.presenting_complaints_ds = new MatTableDataSource(this.emrservice.presentingcomplaints.slice());
    this.enabledisablebtn = false;
  }
  private _filterComplaints(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allComplaintsList.filter(complaint =>
      complaint.complaintName.toLowerCase().includes(filterValue)
    );
  }

  returndisplayvalue(unit,duration){
   if(duration >=1 && duration <=31){
   return duration + " " + unit
   }else{
    return duration
   }
  }
  ngOnDestroy() {
    this.destroypresent$.next(true);
    this.destroypresent$.unsubscribe();
    this.allComplaintsList = null;
    this.sitelist = null;
    this.displayedColumns_presenting_complaints = null;
  }
  // filterpcdata(event){

  //   if(event !=null && event !=''){
  //     var pdata= event
  //   }else{
  //      pdata =0;
  //   }
  //    this.emrservice.getAllComplaints(pdata,0).pipe(takeUntil(this.destroypresent$)).subscribe((item:any)=>{
  //     this.allComplaintsList=item;
  //   })

  // }



  showAllComplaints(id: string | number) {
    this.filteredComplaints[id] = this.allComplaintsList;
  }

  showComplaints() {
    this.filteredComplaint = this.allComplaintsList;
  }

  // // Method to filter complaints when typing in the input field
  filterpceditdata(searchText: string, id: string | number) {
    if (searchText && searchText.trim() !== '') {
      this.emrservice.getAllComplaints(searchText, 0)
        .pipe(takeUntil(this.destroypresent$))
        .subscribe((items: any) => {
          // Filter the complaints for this input field
          this.filteredComplaints[id] = items.filter(item => item.isActive);
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    } else {
      // If the search text is empty, show all complaints
      this.filteredComplaints[id] = this.allComplaintsList;
    }
  }

  filteredComplaint: any;
  getComplaint() {
    // Fetching all complaints from API
    this.emrservice.getAllComplaints(0, 0)
      .pipe(takeUntil(this.destroypresent$))
      .subscribe((x: any) => {
        this.allComplaintsList = x.filter(item => item.isActive);
        // Initially, set filtered complaints to the full list
        this.filteredComplaint = [...this.allComplaintsList];
      }, err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  // Filter complaints based on search input
  filterpcdata(searchText: string) {
    if (searchText && searchText.trim() !== '') {
      this.emrservice.getAllComplaints(searchText, 0)
        .pipe(takeUntil(this.destroypresent$))
        .subscribe((items: any) => {
          this.filteredComplaint = items.filter(item => item.isActive);
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    } else {
      // Reset to the full list when search is cleared
      this.filteredComplaint = [...this.allComplaintsList];
    }
  }

  getSite() {
    this.emrservice.getMasterSite().pipe(takeUntil(this.destroypresent$)).subscribe(data => {
      this.sitelist = data;
      this.siteControl();
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  siteControl() {
    this.filteredSiteArray = this.siteCtrl.valueChanges
      .pipe(startWith(''),
        map(e => e ? this.filtersitefunction(e) : this.sitelist.slice())
      );

    this.filteredSiteArray1 = this.siteCtrl1.valueChanges
      .pipe(startWith(''),
        map(e => e ? this.filtersite(e) : this.sitelist.slice())
      );
  }

  filtersitefunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.sitelist.filter(item => item.site?.toLowerCase().indexOf(filterValue) === 0);
  }

  filtersite(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.sitelist.filter(item => item.site?.toLowerCase().indexOf(filterValue) === 0);
  }

  savecomplaints(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    if (this.emrservice.PresentingComplaintsPermission.isAddPermission == true) {

      let filterComplaintary = this.presenting_complaints_ds.data.filter(item => item.pkComplaintId == 0);
      if (filterComplaintary.length == 0) {
        return this.dashboardService.openSnackBar("Please Add the Complaint Name ", "Ok")
      }

      let siteMissing = filterComplaintary.some(item => !item.site || item.site.trim() === "");
      if (siteMissing) {
        return this.dashboardService.openSnackBar("Please Add the Site Name", "Ok");
      }

      // this.emrservice.open_loader_Dialog();
      this.showspinner = true;
      const savepayload = { OpdComplaintsDetail: filterComplaintary }
      this.emrservice.savecomplaints_on_server(savepayload).pipe(takeUntil(this.destroypresent$)).subscribe(
        data => this.success_save_complaints(data), err => this.failed_save_complaints(err)
      )
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "ok");
    }
  }
  success_save_complaints(data) {
    if (data['statusCode'] == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list","OK");
      this.showspinner = false;
    }
    if(data['statusCode'] == 1){
    this.enabledisablebtn = true;
    this.get_complaints_PE();
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    // this.dialog.closeAll();
    }
  }
  failed_save_complaints(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("save complaints api failed ", "OK");
  }

  get_complaints_PE() {
    this.emrservice.get_complaints_PE().pipe(takeUntil(this.destroypresent$)).subscribe(
      data => this.success_complaints(data), err => this.failed_complaints(err)
    )
  }
  success_complaints(data) {
    this.showspinner = false;
   // this.emrservice.presentingcomplaints = data;
  //  console.log(this.emrservice.presentingcomplaints, 'called presentingcomplaints')
    if(data.length >0){
      this.presenting_complaints_ds = new MatTableDataSource(data.slice());
    }else{
      this.presenting_complaints_ds = new MatTableDataSource(this.emrservice.presentingcomplaints.slice());
    }
    this.complaintupdateEdit();
  }
  failed_complaints(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("get complaints api failed ", "OK");
  }

  changeComplaint(item, idx) {
    if (this.rowSelect != idx) {
      this.rowSelect = idx;
      this.emrservice.add_presentingcomplaints.complaint = item.complaintName;
    } else {
      this.rowSelect = -1;
      this.emrservice.add_presentingcomplaints.complaint = '';
    }
  }
  defValue() {
    this.emrservice.add_presentingcomplaints.pkComplaintId = 0;
    this.emrservice.add_presentingcomplaints.pkSynchId = null;
    this.emrservice.add_presentingcomplaints.oldoptoId = null;
    this.emrservice.add_presentingcomplaints.unit = null;
    this.emrservice.add_presentingcomplaints.IsEdit = 0;
    this.emrservice.add_presentingcomplaints.IsDelete = 0;
    this.emrservice.add_presentingcomplaints.complaint = '';
    this.rowSelect = -1;
    this.selectSite = '';
    this.searchValue = '';
  }

  addcomplaint(type: any) {
    if(this.emrservice.add_presentingcomplaints.year >0){
      this.emrservice.add_presentingcomplaints.unit ='year'
    }else if(this.emrservice.add_presentingcomplaints.year == 0 && this.emrservice.add_presentingcomplaints.month >0){
      this.emrservice.add_presentingcomplaints.unit ='month'
    }else if(this.emrservice.add_presentingcomplaints.year == 0 && this.emrservice.add_presentingcomplaints.month == 0 && this.emrservice.add_presentingcomplaints.days >0){
      this.emrservice.add_presentingcomplaints.unit ='day'
   }
    let addlist = this.emrservice.add_presentingcomplaints;
    if (addlist.complaint == '') {
      return this.dashboardService.openSnackBar("Please select the Complaint Name ", "Ok")
    }

    if (addlist.year > 0 && addlist.month == 0 && addlist.days == 0) {
      this.unitDuration = addlist.year == 1 ? addlist.year + ' Year ' : addlist.year + ' Years ';
      
    } else if (addlist.month > 0 && addlist.year == 0 && addlist.days == 0) {
      this.unitDuration = addlist.month == 1 ? addlist.month + ' Month ' : addlist.month + ' Months '
    } else if (addlist.days > 0 && addlist.month == 0 && addlist.year == 0) {
      this.unitDuration = addlist.days == 1 ? addlist.days + ' Day' : addlist.days + ' Days';
    } else if (addlist.year > 0 && addlist.days > 0 && addlist.month == 0) {
      let yr = addlist.year == 1 ? addlist.year + ' Year ' : addlist.year + ' Years ';
      let day = addlist.days == 1 ? addlist.days + ' Day' : addlist.days + ' Days';
      this.unitDuration = yr + day;
    }
    else if (addlist.month > 0 && addlist.days > 0 && addlist.year == 0) {
      let mth = addlist.month == 1 ? addlist.month + ' Month ' : addlist.month + ' Months ';
      let day = addlist.days == 1 ? addlist.days + ' Day' : addlist.days + ' Days';
      this.unitDuration = mth + day;
    }
    else if (addlist.year > 0 && addlist.month > 0 && addlist.days == 0) {
      let yr = addlist.year == 1 ? addlist.year + ' Year ' : addlist.year + ' Years ';
      let mth = addlist.month == 1 ? addlist.month + ' Month ' : addlist.month + ' Months ';
      this.unitDuration = yr + mth;
    } else if (addlist.year > 0 && addlist.month > 0 && addlist.days > 0) {
      let yr = addlist.year == 1 ? addlist.year + ' Year ' : addlist.year + ' Years ';
      let mth = addlist.month == 1 ? addlist.month + ' Month ' : addlist.month + ' Months ';
      let day = addlist.days == 1 ? addlist.days + ' Day' : addlist.days + ' Days';
      this.unitDuration = yr + mth + day;
    } else if (
      addlist.year == 0 && addlist.month == 0 && addlist.days == 0
    ) {
      return this.dashboardService.openSnackBar("Zero Days not Allowed", "OK");
    }
   
    //  this.unitDuration = addlist.year + 'Y ' + addlist.month + 'M ' + addlist.days + 'D';
    addlist.duration = addlist.sdate == null || addlist.sdate == '' ? addlist.duration : this.unitDuration;
    addlist.site = addlist.site == null || addlist.site == '' ? this.selectSite : addlist.site;
    addlist.fkVisitId = this.emrservice.visitid;
    if (addlist.site == '') {
      return this.dashboardService.openSnackBar("Please select the Site Name ", "Ok")
    }


    let isDuplicate = this.emrservice.presentingcomplaints.some(item => 
      item.complaint === addlist.complaint && item.site === addlist.site
  );
  if (isDuplicate) {
      return this.dashboardService.openSnackBar("This complaint and site already added !", "OK");
  }
    this.enabledisablebtn = false;

    if (type == 0) {
      this.emrservice.presentingcomplaints.push(addlist);
      const addrow = this.presenting_complaints_ds.data.concat(this.emrservice.presentingcomplaints);
      this.presenting_complaints_ds = new MatTableDataSource(addrow.slice());
      this.emrservice.add_presentingcomplaints = {};
      this.assigndata();
      this.rowSelect = -1;
      document.getElementById("presentcomplaintsModal").style.display = "none";

    } else if (type == 1) {
      this.emrservice.presentingcomplaints.push(addlist);
      this.emrservice.add_presentingcomplaints = {};
      this.assigndata();
      this.rowSelect = -1;
    }

  }
  assigndata(){
    this.emrservice.add_presentingcomplaints.pkComplaintId=0;
    this.emrservice.add_presentingcomplaints.pkSynchId=null;
    this.emrservice.add_presentingcomplaints.IsEdit=0;
    this.emrservice.add_presentingcomplaints.IsDelete=0;
    this.emrservice.add_presentingcomplaints.complaint = '';
    this.emrservice.add_presentingcomplaints.sdate = null;
    this.emrservice.add_presentingcomplaints.duration = null;
    this.emrservice.add_presentingcomplaints.site=null;
   
  }
  adduploadcomplaint(){
  //   if(this.emrservice.presentingcomplaints.length >0){
  // console.log(this.emrservice.presentingcomplaints ,'called res')
  //     const addrow = this.presenting_complaints_ds.data.concat(this.emrservice.presentingcomplaints);
  //     console.log(addrow)
  //     this.presenting_complaints_ds = new MatTableDataSource(addrow.slice());
  //     document.getElementById("presentcomplaintsModal").style.display = "none";
  //   }else{
  //     this.dashboardService.openSnackBar("Please add presenting complaints",'ok')
  //   }
  if (this.emrservice.presentingcomplaints.length > 0) {
    const existingComplaints = this.presenting_complaints_ds.data.map((complaint: any) => ({
          complaint: complaint.complaint,
          site: complaint.site
      }));
    const newComplaints = this.emrservice.presentingcomplaints;
    const duplicateComplaints = newComplaints.filter((newComplaint: any) =>
      existingComplaints.some(existing => 
          existing.complaint == newComplaint.complaint && existing.site == newComplaint.site
      )
  );
    if (duplicateComplaints.length > 0) {
      this.dashboardService.openSnackBar("This complaint and site is already uploaded", 'OK');
    } else {
      const addrow = this.presenting_complaints_ds.data.concat(newComplaints);
      this.presenting_complaints_ds = new MatTableDataSource(addrow.slice());
      document.getElementById("presentcomplaintsModal").style.display = "none";
    }
  } else {
    this.dashboardService.openSnackBar("Please add presenting complaints", 'ok');
  }
  }
  deleteindexcomplaint(i: any) {

    this.emrservice.presentingcomplaints.splice(i, 1);
  }

  deletecomplaint(row) {
    this.showspinner = true;
    if (row.pkComplaintId > 0) {
      if (this.emrservice.PresentingComplaintsPermission.isDeletePermission == true) {
        row.IsEdit = 1;
        row.IsDelete = 1;
        let selectItem = row;
        const payload = { OpdComplaintsDetail: [selectItem] }
        this.emrservice.delete_complaint_PE(payload).pipe(takeUntil(this.destroypresent$)).subscribe(
          data => this.success_delete_complaint(data), err => this.failed_delete_complaint(err)
        )
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
        this.showspinner = false;
      }

    }
    else {
      const index: number = this.emrservice.presentingcomplaints.indexOf(row);
      if (index !== -1) {
        this.emrservice.presentingcomplaints.splice(index, 1);
        this.presenting_complaints_ds = new MatTableDataSource(this.emrservice.presentingcomplaints.slice());
      }
      this.showspinner = false;

    }

  }
  success_delete_complaint(data) {
    this.showspinner = false;
    this.get_complaints_PE();
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("complaint deleted successfully", "OK");
  }
  failed_delete_complaint(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("delete complaint api failed", "OK");
  }

  presentcomplaintspopup() {
    if (this.emrservice.PresentingComplaintsPermission.isAddPermission == true) {
      this.emrservice.presentingcomplaints = [];
      document.getElementById("presentcomplaintsModal").style.display = "block";
      this.defValue();
      this.showComplaints()
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
    this.emrservice.add_presentingcomplaints.month = 0;
    this.emrservice.add_presentingcomplaints.days = 0;
    this.emrservice.add_presentingcomplaints.sdate = '';
    this.emrservice.add_presentingcomplaints.year = 0;
    this.emrservice.add_presentingcomplaints.duration = '';


  }


  cancelpresentcomplaints() {
    // if (this.showcomplamintmodel === undefined) {
    //   this.parentdata.emit(this.showcomplamintmodel =false)
    //   this.showDrugAllergyEvent.emit(false);
    // } else {
    //   this.showDrugAllergyEvent.emit(true);
    //   this.parentdata.emit(this.showcomplamintmodel = true)

    // }

    document.getElementById("presentcomplaintsModal").style.display = "none";
    // this.emrservice.add_presentingcomplaints = {};
  }


  cancelcomplaints() {
    document.getElementById("complaintsModal").style.display = "none";
  }
  closecomplaints() {
    document.getElementById("complaintsModal").style.display = "none";
  }
  comDurationPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 0) {
        if (type == 27) {
          this.emrservice.add_presentingcomplaints.duration = result;
          if (this.emrservice.add_presentingcomplaints.duration != '') {
            this.removeUnitObj();
          }
        }
      }
    });
  }
  removeUnitObj() {
    this.emrservice.add_presentingcomplaints.sdate = '';
    this.emrservice.add_presentingcomplaints.year = null;
    this.emrservice.add_presentingcomplaints.month = null;
    this.emrservice.add_presentingcomplaints.days = null;
    this.emrservice.add_presentingcomplaints.unit=null;
    this.selectSite = '';
  }
  selectUnitEye(e: any, index: number) {
    if (e != null) {
      this.selectSite = e;
    }
    if (this.selectSite != '') {
      this.emrservice.add_presentingcomplaints.duration = null;
      this.emrservice.add_presentingcomplaints.site = '';
    }
  }

  selectCompEye(name) {
    if (this.emrservice.add_presentingcomplaints.site != '') {
      this.removeUnitObj();
    }
  }
  onSitechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.add_presentingcomplaints.site = e;
    }
    if (this.emrservice.add_presentingcomplaints.site != '') {
      this.removeUnitObj();
    }
  }
  getage(selecteddate: string) {
    const checkcdate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.authService.getServerDate;
    if (currentdate >= checkcdate) {
      this.getDataDiff(new Date(selecteddate), new Date(currentdate));
    } else {
      this.emrservice.add_presentingcomplaints.sdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.emrservice.add_presentingcomplaints.year = 0;
      this.emrservice.add_presentingcomplaints.month = 0;
      this.emrservice.add_presentingcomplaints.days = 0;
    }
  }
  getToday(): string {
    return this.authService.localDate.toISOString().split('T')[0]
  }
  getDataDiff(start, end) {
    let years: number = 0, months: number = 0, days: number;
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }
    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }
    years += end.getFullYear() - start.getFullYear();
    this.emrservice.add_presentingcomplaints.year = years;
    this.emrservice.add_presentingcomplaints.month = months;
    this.emrservice.add_presentingcomplaints.days = days;
    this.emrservice.add_presentingcomplaints.duration = null;
    this.emrservice.add_presentingcomplaints.site = '';
  }
  // getdob(type: any) {
  //   switch (type) {
  //     case 1: {
  //       // var tdate = this.authService.localDate;
  //       var tdate = new Date(this.authService.localDate); 
  //       if (this.emrservice.add_presentingcomplaints.year == null || this.emrservice.add_presentingcomplaints.year == undefined) {
  //         this.emrservice.add_presentingcomplaints.year = 0;
  //       }
  //       this.emrservice.add_presentingcomplaints.month = 0;
  //       this.emrservice.add_presentingcomplaints.days = 0;
  //       tdate.setDate(tdate.getUTCDate() - this.emrservice.add_presentingcomplaints.days || 0);
  //       tdate.setMonth(tdate.getMonth() - this.emrservice.add_presentingcomplaints.month || 0);
  //       tdate.setFullYear(tdate.getFullYear() - this.emrservice.add_presentingcomplaints.year || 0);
  //       this.emrservice.add_presentingcomplaints.sdate = this.datePipe.transform(tdate, "yyyy-MM-dd");
  //       break;
  //     }
  //     case 2: {
  //       // var tdate = this.authService.localDate;
  //       var tdate = new Date(this.authService.localDate); 

  //       if (this.emrservice.add_presentingcomplaints.month > 11 || this.emrservice.add_presentingcomplaints.month <= 0) {
  //         this.dashboardService.openSnackBar("Please enter months in between 0 to 12", "OK");
  //         this.emrservice.add_presentingcomplaints.month = null;
  //         return false;
  //       }
  //       if (this.emrservice.add_presentingcomplaints.year == undefined || this.emrservice.add_presentingcomplaints.year == null) {
  //         this.emrservice.add_presentingcomplaints.year = 0;
  //       }
  //       this.emrservice.add_presentingcomplaints.days = 0;
  //       tdate.setDate(tdate.getUTCDate() - this.emrservice.add_presentingcomplaints.days|| 0);
  //       tdate.setMonth(tdate.getMonth() - this.emrservice.add_presentingcomplaints.month || 0);
  //       tdate.setFullYear(tdate.getFullYear() - this.emrservice.add_presentingcomplaints.year || 0);
  //       this.emrservice.add_presentingcomplaints.sdate = this.datePipe.transform(tdate, "yyyy-MM-dd");
  //       break;
  //     }
  //     case 3: {
  //       // var tdate = this.authService.localDate;
  //       var tdate = new Date(this.authService.localDate); 

  //       if (this.emrservice.add_presentingcomplaints.days > 31 || this.emrservice.add_presentingcomplaints.days < 0) {
  //         this.dashboardService.openSnackBar("Please enter days in between 0 to 31", "OK");
  //         this.emrservice.add_presentingcomplaints.days = null;
  //         return false;
  //       }
  //       if ((this.emrservice.add_presentingcomplaints.month == undefined || this.emrservice.add_presentingcomplaints.month == null) && (this.emrservice.add_presentingcomplaints.year == undefined || this.emrservice.add_presentingcomplaints.year == null)) {
  //         this.emrservice.add_presentingcomplaints.month = 0;
  //         this.emrservice.add_presentingcomplaints.year = 0;
  //       }
  //       tdate.setDate(tdate.getUTCDate() - this.emrservice.add_presentingcomplaints.days || 0);
  //       tdate.setMonth(tdate.getMonth() - this.emrservice.add_presentingcomplaints.month || 0);
  //       tdate.setFullYear(tdate.getFullYear() - this.emrservice.add_presentingcomplaints.year || 0);
  //       this.emrservice.add_presentingcomplaints.sdate = this.datePipe.transform(tdate, "yyyy-MM-dd");
  //     }
  //   }
  //   if (this.emrservice.add_presentingcomplaints.sdate != '') {
  //     this.emrservice.add_presentingcomplaints.duration = null;
  //     this.emrservice.add_presentingcomplaints.site = '';
  //   }
  // }


  getdob(type: any) {
    var tdate = new Date(this.authService.localDate);
    switch (type) {
      case 1: {
        this.emrservice.add_presentingcomplaints.year = this.emrservice.add_presentingcomplaints.year || 0;
        this.emrservice.add_presentingcomplaints.month = this.emrservice.add_presentingcomplaints.month || 0;
        this.emrservice.add_presentingcomplaints.days = this.emrservice.add_presentingcomplaints.days || 0;
        break;
      }
      case 2: {
        if (this.emrservice.add_presentingcomplaints.month > 11 || this.emrservice.add_presentingcomplaints.month <= 0) {
          this.dashboardService.openSnackBar("Please enter months in between 0 to 12", "OK");
          this.emrservice.add_presentingcomplaints.month = 0;
          return;
        }
        this.emrservice.add_presentingcomplaints.year = this.emrservice.add_presentingcomplaints.year || 0;
        // this.emrservice.add_presentingcomplaints.month = this.emrservice.add_presentingcomplaints.month || 0;
        this.emrservice.add_presentingcomplaints.days = 0;
        break;
      }
      case 3: {
        if (this.emrservice.add_presentingcomplaints.days > 31 || this.emrservice.add_presentingcomplaints.days < 0) {
          this.dashboardService.openSnackBar("Please enter days in between 0 to 31", "OK");
          this.emrservice.add_presentingcomplaints.days = null;
          return;
        }
        this.emrservice.add_presentingcomplaints.month = this.emrservice.add_presentingcomplaints.month || 0;
        this.emrservice.add_presentingcomplaints.year = this.emrservice.add_presentingcomplaints.year || 0;
        break;
      }
    }


    tdate.setDate(tdate.getUTCDate() - (this.emrservice.add_presentingcomplaints.days || 0));
    tdate.setMonth(tdate.getMonth() - (this.emrservice.add_presentingcomplaints.month || 0));
    tdate.setFullYear(tdate.getFullYear() - (this.emrservice.add_presentingcomplaints.year || 0));


    if (isNaN(tdate.getTime())) {
      this.dashboardService.openSnackBar("Resulting date is invalid. Please check your inputs.", "OK");
      return;
    }


    this.emrservice.add_presentingcomplaints.sdate = this.datePipe.transform(tdate, "yyyy-MM-dd");

    if (this.emrservice.add_presentingcomplaints.sdate) {
      this.emrservice.add_presentingcomplaints.duration = null;
      this.emrservice.add_presentingcomplaints.site = '';
    }
  }


  openComplaintMaster(item, type) {
   
    document.getElementById("complaintMasterModal").style.display = "block";
    this.savetype = type;
    if (this.savetype == 'add') {
      this.pkId = 0;
      this.complaintname = '';
    } else {
      this.pkId = item.pkComplaintId;
      this.compCategoryId = item.fkCompCategoryId;
      this.complaintname = item.complaintName;
    }
 
  }

  cancelcomplaintMaster() {
    document.getElementById("complaintMasterModal").style.display = "none";
    this.complaintname = '';
  }


  saveComplaintMaster() {
    let payloadary;
    if (this.pkId != 0) {
      payloadary = {
        "ComplaintMaster": {
          "IsEdit": true,
          "IsDelete": false,
          "PkComplaintId": this.pkId,
          "ComplaintName": this.complaintname,
          "FkCompCategoryId": this.compCategoryId,
          "IsActive": true
        }
      }
    } else {
      payloadary = {
        "ComplaintMaster": {
          "IsEdit": false,
          "IsDelete": false,
          "PkComplaintId": 0,
          "ComplaintName": this.complaintname,
          "FkCompCategoryId": 1,
          "IsActive": true
        }
      }
    }
    this.emrservice.InsertComplaintMaster(payloadary).pipe(takeUntil(this.destroypresent$)).subscribe(data =>
      this.success_cmplte_master(data), err => this.failed_cmplte_master(err)
    );
  }

  success_cmplte_master(data) {
    this.getComplaint();
    this.cancelcomplaintMaster();
    if (this.savetype == 'add') {
      this.dashboardService.openSnackBar("Record Saved Successfully ", "OK");
    } else {
      this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
    }
  }

  failed_cmplte_master(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("Save Complaint Master api failed ", "OK");
  }
  complaintid: any;
  complaintupdateEdit(): void {
    this.presenting_complaints_ds.data.forEach((item, index) => {
      const id = item.pkComplaintId || index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };

    });

  }
  Edit(pkid: string, index) {
   
    if (this.emrservice.PresentingComplaintsPermission.isModifyPermission == true) {
      const id = pkid || index;
      this.complaintupdateEdit()
      this.editCache[id].edit = true;
      this.complaintid = id;
      this.complaintNaMe = this.editCache[id].data.pkComplaintId
    } else {
      this.dashboardService.openSnackBar("Modify Permission Denied", "OK");
    }
  }


  complaintsSaveEdit(pkid, idx): void {
    const id = pkid || idx;
    var isedit
    let payloadarray = [];
    let editlist = this.editCache[id].data;
    if (editlist.pkComplaintId == 0) {
      isedit = false;
    } else {
      isedit = true;
    }
    if(!editlist.site){
      this.dashboardService.openSnackBar("Please Select Site Name", "OK");
      return
    }

    if(!editlist.complaint){
      this.dashboardService.openSnackBar("Please select the Complaint Name", "OK");
      return
    }
   
    payloadarray.push({
      "pkComplaintId": editlist.pkComplaintId,
      "fkVisitId": editlist.fkVisitId,
      "complaint": editlist.complaint,
      "duration": editlist.duration,
      "site": editlist.site,
      "unit": editlist.unit,
      "oldoptoId": editlist.oldoptoId,
      "pkSynchId": editlist.pkSynchId,
      "IsEdit": isedit,
      "IsDelete": false,
      "year": this.emrservice.add_presentingcomplaints.year,
      "month": this.emrservice.add_presentingcomplaints.month,
      "days": this.emrservice.add_presentingcomplaints.days,
      "sdate": this.emrservice.add_presentingcomplaints.sdate
    });
    this.editCache[id].edit = false;
    let editpayload = {
      "OpdComplaintsDetail": payloadarray
    }
    this.emrservice.savecomplaints_on_server(editpayload).pipe(takeUntil(this.destroypresent$)).subscribe(
      data => this.success_complaint_update(data), err => this.failed_complaint_update(err)
    )
  }
  success_complaint_update(data) {
    if (data['statusCode'] == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list","OK");
    }
    if(data['statusCode'] == 1){
    this.get_complaints_PE();
    this.enabledisablebtn = true;
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
  }
  }
  failed_complaint_update(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  checkvalue(name) {
    let val = name.trimStart();
    if (val == '') {
      this.emrservice.add_presentingcomplaints.pkComplaintId = null;
      this.complaintNaMe = ''
      //  this.complaintid = 0;
    }
  }


  selectCompliantNames(e) {
   
    this.editCache[this.complaintid].data.complaintName = e.option.value;
    this.editCache[this.complaintid].data.pkComplaintId = e.option.id;
  }



  addduration() {
    
    // const id = pkid;
    if(this.emrservice.add_presentingcomplaints.year >0){
      this.emrservice.add_presentingcomplaints.unit ='year'
    }else if(this.emrservice.add_presentingcomplaints.year == 0 && this.emrservice.add_presentingcomplaints.month >0){
      this.emrservice.add_presentingcomplaints.unit ='month'
    }else if(this.emrservice.add_presentingcomplaints.year == 0 && this.emrservice.add_presentingcomplaints.month == 0 && this.emrservice.add_presentingcomplaints.days >0){
      this.emrservice.add_presentingcomplaints.unit ='day'
   }
    let listadd = this.emrservice.add_presentingcomplaints;
    if (listadd.year > 0 && listadd.month == 0 && listadd.days == 0) {
      this.unitDuration = listadd.year == 1 ? listadd.year + ' Year ' : listadd.year + ' Years ';
    } else if (listadd.month > 0 && listadd.year == 0 && listadd.days == 0) {
      this.unitDuration = listadd.month == 1 ? listadd.month + ' Month ' : listadd.month + ' Months ';
    } else if (listadd.days > 0 && listadd.month == 0 && listadd.year == 0) {
      this.unitDuration = listadd.days == 1 ? listadd.days + ' Day' : listadd.days + ' Days';
    } else if (listadd.year > 0 && listadd.days > 0 && listadd.month == 0) {
      let yr = listadd.year == 1 ? listadd.year + ' Year ' : listadd.year + ' Years ';
      let day = listadd.days == 1 ? listadd.days + ' Day' : listadd.days + ' Days';
      this.unitDuration = yr + day;
    } else if (listadd.month > 0 && listadd.days > 0 && listadd.year == 0) {
      let mth = listadd.month == 1 ? listadd.month + ' Month ' : listadd.month + ' Months ';
      let day = listadd.days == 1 ? listadd.days + ' Day' : listadd.days + ' Days';
      this.unitDuration = mth + day;
    } else if (listadd.year > 0 && listadd.month > 0 && listadd.days == 0) {
      let yr = listadd.year == 1 ? listadd.year + ' Year ' : listadd.year + ' Years ';
      let mth = listadd.month == 1 ? listadd.month + ' Month ' : listadd.month + ' Months ';
      this.unitDuration = yr + mth;
    } else if (listadd.year > 0 && listadd.month > 0 && listadd.days > 0) {
      let yr = listadd.year == 1 ? listadd.year + ' Year ' : listadd.year + ' Years ';
      let mth = listadd.month == 1 ? listadd.month + ' Month ' : listadd.month + ' Months ';
      let day = listadd.days == 1 ? listadd.days + ' Day' : listadd.days + ' Days';
      this.unitDuration = yr + mth + day;
    } else if (listadd.year == 0 && listadd.month == 0 && listadd.days == 0) {
      return this.dashboardService.openSnackBar("Zero Days not Allowed", "OK");
    }

    this.enabledisablebtn = false;
    listadd.duration = listadd.sdate == null || listadd.sdate == '' ? listadd.duration : this.unitDuration;
    listadd.site = listadd.site == null || listadd.site == '' ? this.selectSite : listadd.site;
    listadd.fkVisitId = this.emrservice.visitid;


    if (this.editCache[this.complaintid]) {
      this.editCache[this.complaintid].data.duration = this.emrservice.add_presentingcomplaints.duration
      this.editCache[this.complaintid].data.unit = this.emrservice.add_presentingcomplaints.unit
    }
    this.emrservice.add_presentingcomplaints = {};

    document.getElementById("complaintsModal").style.display = "none";
  }

  clearTimeandDate() {
    this.emrservice.add_presentingcomplaints.month = 0;
    this.emrservice.add_presentingcomplaints.days = 0;
    this.emrservice.add_presentingcomplaints.sdate = '';
    this.emrservice.add_presentingcomplaints.year = 0;
  }


  durationpopup() {
 
    const selectedComplaint = this.editCache[this.complaintid].data
    if (selectedComplaint) {
      this.emrservice.add_presentingcomplaints = { ...selectedComplaint };
    } else {
      this.emrservice.add_presentingcomplaints = {};
    }
    document.getElementById("complaintsModal").style.display = "block";
    this.clearTimeandDate();

  }


  cancelEdit(pkid, idx): void {
    const id = pkid || idx;
    this.editCache[id].edit = false;
  }


  closedialog() {
    this.dialogRef.close();
  }
}
